<template>
  <div class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage"
       :data-active-color="activeColor">

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="logo">
        <router-link to="/dashboard" class="beast-logo">
          Beast Repository
        </router-link>
        <router-link to="/dashboard" class="beast-logo-small">
          Beast
        </router-link>
      </div>
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
import "perfect-scrollbar/dist/css/perfect-scrollbar.css";
import PerfectScroll from "perfect-scrollbar";

import bkgImage from "../../assets/img/sidebar-5.jpg";

export default {
  name: "sidebar",
  props: {
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        const acceptedValues = ["", "blue", "azure", "green", "orange", "red", "purple", "black"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        const acceptedValues = ["primary", "info", "success", "warning", "danger"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  computed: {
    backgroundImage() {
      return bkgImage;
    },
    sidebarStyle() {
      return {
        backgroundImage: `url(${bkgImage})`
      };
    }
  },
  methods: {
    async initScrollBarAsync() {
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    }
  },
  mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};

</script>
<style scoped>

</style>
